//@flow
import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'

import { Button, Error, Flex } from 'components/common'
import { UploadController } from 'components/common/form'
import { useI18n } from '~/core/i18n'

type UploadTemplateProps = {
  error?: any,
  accept?: string,
  isLoading?: boolean,
  onUpload: (filenames: File[]) => void
}

const UploadTemplate = ({ accept, error, isLoading, onUpload }: UploadTemplateProps) => {
  const [msg] = useI18n()
  const formMethods = useForm({
    defaultValues: {
      filenames: []
    }
  })

  const handleSubmit = data => onUpload(data.filenames)

  return (
    <FormProvider {...formMethods}>
      <Flex
        as="form"
        column
        style={{
          minWidth: 450,
          maxWidth: '50vw',
          padding: '0 0.5rem'
        }}
        onSubmit={formMethods.handleSubmit(handleSubmit)}
      >
        {error && <Error reason={error} />}
        <UploadController
          accept={accept}
          label={`${msg('common.upload.chooseFile')}${accept !== undefined ? ` (${accept})` : ''}`}
          name="filenames"
        />
        <Flex
          justifyCenter
          style={{
            marginTop: '1.5rem'
          }}
        >
          <Button
            disabled={isLoading || !formMethods.formState.isDirty}
            iconPosition="left"
            id="template-upload-btn"
            type="submit"
            xIcon="upload"
            onClick={onUpload}
          >
            {isLoading ? msg('common.button.uploading') : msg('common.button.upload')}
          </Button>
        </Flex>
      </Flex>
    </FormProvider>
  )
}

export default UploadTemplate
